<template lang="pug">
  .main-chair(:class="{'main-chair-canter': isFukkafuka }")
    .title
      h1.title-logo
        a.title-logo-image(href='./'): img(src='@/assets/image/logo.svg' alt='Serio Mμ')
        .title-type
          img.title-type-image(:src="require(`@/assets/image/typec.svg`)" alt='chair type')
          //- figure.title-type-label
      .title-heading
        h3.title-heading-wrap
          img.title-heading-word(:src="require(`@/assets/image/color_simulator.svg`)" alt='COLOR SIMULATOR')
    .main-chair-views
      figure.main-chair-view(v-for="model in getAllModels" :ref="model" :data-type='model')
        .img-back
          transition(name='fadeback')
            img(v-if="!isFukkafuka" :src="require(`@/assets/image/floor.png`)")
          img.back-hide(:src="require(`@/assets/image/floor-canter.png`)")
          transition(name='fadeback')
            img(v-if="isFukkafuka" :src="require(`@/assets/image/floor-canter.png`)")
        .seat
          template(v-for="image in seats(model)")
            transition(name='fade')
              .img-main(
                v-if="isCurrentSeat(image)"
                :class="[{ active : isCurrentSeat(image)}, {'img-main-canter': isFukkafuka}]"
              ): img(:src="image.file")
        .unit.unita
          template(v-for="image in unitsA(model)")
            transition(name='fade')
              .img-main(v-if="isCurrentUnit(image)" :class="[{ active: isCurrentUnit(image)}, {'img-main-canter': isFukkafuka}]"): img(:src="image.file")
        .unit.unitb
          template(v-for="image in unitsB(model)")
            transition(name='fade')
              .img-main(v-if="isCurrentUnit(image)" :class="[{ active: isCurrentUnit(image)}, {'img-main-canter': isFukkafuka}]"): img(:src="image.file")
        .unit.cabinet
          template(v-for="image in cabinets(model)")
            transition(name='fade')
              .img-main(v-if="isCurrentCabinet(image)" :class='{ active: isCurrentCabinet(image)}'): img(:src="image.file")
    color-status(v-if="isSp")
</template>
<script>
import SelectStatus from '@/components/SelectStatus.vue';
import { mapGetters } from 'vuex';
export default {
  // 画像表示箇所
  name: 'SelectView',
  components: {
    'color-status': SelectStatus,
  },
  computed: {
    ...mapGetters([
      'getColorsArray',
      'isCurrentUnit',
      'isCurrentSeat',
      'isCurrentCabinet',
      'isSp',
      'getAllModels',
      'getSubCategory',
      'getCurrentSubCategory',
    ]),
    unitsA() {
      return function (model) {
        return this.getColorsArray
          .filter((item) => item.model === model && item.type === 'unit')
          .filter((item) => item.parts.find((it) => it.type == 'unitA'))
          .map((item) => {
            const buff = item.parts.find((it) => it.type == 'unitA');
            buff.code = item.code;
            return buff;
          });
      };
    },
    unitsB() {
      return function (model) {
        return this.getColorsArray
          .filter((item) => item.model === model && item.type === 'unit')
          .filter((item) => item.parts.find((it) => it.type == 'unitB'))
          .map((item) => {
            const buff = item.parts.find((it) => it.type == 'unitB');
            buff.code = item.code;
            return buff;
          });
      };
    },
    cabinets() {
      return function (model) {
        return this.getColorsArray.filter(
          (item) => item.model === model && item.type === 'cabinet'
        );
      };
    },
    seats() {
      return function (model) {
        return this.getColorsArray.filter(
          (item) => item.model === model && item.type === 'seat'
        );
      };
    },
    isFukkafuka() {
      return this.getCurrentSubCategory.indexOf('Fukka-Fuka') >= 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.main-chair {
  position: relative;
  display: flex;
  flex: 1;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  width: calc(100% - 298px);
  min-width: calc(100% - 298px);
  background: linear-gradient(
    152deg,
    #b8c4d8 0%,
    #bdc7da 49%,
    #c4cede 50%,
    #d1d7e2 51%,
    #d8dce4 100%
  );

  .title {
    position: absolute;
    top: 38px;
    left: 34px;
    z-index: 333;

    &-logo {
      z-index: 1;
      display: flex;
      align-items: baseline;
      width: 100%;

      &-image {
        display: block;
        width: 184px;

        img {
          width: 100%;
        }
      }

      &-modelR {
        margin-left: 2px;
      }
    }

    &-type {
      width: 56px;
      padding: 2px 4px;
      margin-left: 8px;
      border: 1px solid #000;
      display: flex;
      align-items: center;
      justify-content: center;

      &-image {
        // width: 48px;
        width: 80%;
      }
    }

    &-heading {
      &-wrap {
        width: 253px;
      }

      &-word {
        width: 100%;
      }
    }
  }

  &-views {
    width: 100%;
    min-width: auto;
  }

  &-view {
    position: relative;
    width: 100%;

    .img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      img {
        width: 100%;
      }
    }

    .img-back {
      @extend .img;

      width: 125%;
      height: auto;
      transform: translate(-50.8%, -49.2%);

      .back-hide {
        display: none;
      }
    }

    .img-main {
      @extend .img;

      width: 64.8%;
      height: auto;
      transform: translate(-48.7%, -51.1%);
    }

    .img-main-canter {
      width: 50%;
      transform: translate(-17.8%, -35.6%);
    }
  }
}

.unit {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;

  &.unita {
    z-index: 3;
  }

  &.unitb {
    z-index: 1;
  }
}

.seat {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
}

.cabinet {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;

  .img-main {
    transform: translate(-49.5%, -51.1%);
  }
}

@include pc-layout {
  .main-chair {
    .title {
      a {
        opacity: 1;
        will-change: opacity;
        transition: opacity 250ms ease-in-out;

        &:hover {
          opacity: 0.6;
        }
      }
    }
  }
}
@include sp-layout {
  .main-chair {
    flex: 1;
    width: 100%;
    height: calc(100% - #{vw(430)});
    background: linear-gradient(
      152deg,
      #b8c4d8 0%,
      #bdc7da 49%,
      #c4cede 50%,
      #c6d0df 51%,
      #dbe0e9 100%
    );

    .title {
      top: vw(24);
      left: vw(34);

      &-logo {
        &-image {
          width: vw(200);
        }

        &-modelR {
          margin-left: vw(2);

          &-image {
            width: vw(58);
            height: vw(38);
          }
        }
      }

      &-type {
        &-label {
          width: vw(52);
          padding: vw(2) vw(8) vw(2) vw(12);
          margin-left: vw(12);
        }

        width: vw(48);
      }

      &-heading {
        &-wrap {
          width: vw(282);
        }
      }
    }

    &-views {
      margin-top: vw(-150);
    }

    &-view {
      width: 100%;
      min-width: auto;
      margin-top: vw(150);

      $img_back_width: calc(100vw + 300px);

      .img-back {
        width: $img_back_width;
        transform: translate(-52%, -50%);
        object-fit: cover;
      }

      .img-main {
        width: 100%;
        width: calc(#{$img_back_width} * 0.533);
        height: initial;
        transform: translate(-52.5%, -53%);
        object-fit: cover;
      }

      .img-main-canter {
        width: calc(#{$img_back_width} * 0.413);
        transform: translate(-22.4%, -38%);
      }
    }
  }
}
</style>
